// @core/api/endpoints/affiliate/track_conversion.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ConversionResponse,
  TrackConversionRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Track conversion
 * Records a conversion event. Can be called via postback URL, server-to-server API, or Kafka consumer.
 * @public This endpoint does not require authentication
 */
export async function TrackConversion(
  data: TrackConversionRequest,
  options?: RequestOptions
): Promise<ConversionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/track/conversion`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<ConversionResponse>(requestPath, data, requestOptions);
}
